.unit {
  font-size: 8px;
  line-height: 12px;
  margin-top: 6px;
  margin-left: 5px;
}

.flexRowWrapper {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
  flex-direction: row;
  gap: 4px;
}

.skeletonLoaderWrapper {
  display: flex;
  justify-content: flex-end;
}

.indicator {
  margin-left: 10px;
  border-radius: 50%;
  width: 8px;
  height: 8px;
}

.default {
  color: var(--text-default);
}

.negative {
  color: var(--viz-bearish);
}

.positive {
  color: var(--viz-bullish);
}

.disabled {
  color: var(--text-disabled);
}

.indicatorDefault {
  background-color: var(--text-soft);
}

.indicatorLivePrice {
  background-color: var(--viz-bullish);
}
